export default __webpack_public_path__ + "static/media/totebag.d5170d3b.jpg";